import React from 'react';
import styles from './wc-tag.module.scss';
import { CdnImg } from '@/features/cdn-img';
import clsx from 'clsx';
import { useWcPromotionActivityNavigation } from '@/domains/wc-promotion/hooks/use-wc-promotion-activity-navigation';
import { useWcPromotionActivityAssetLocale } from '@/domains/wc-promotion/hooks/use-wc-promotion-support-lang';
import { KafkaNote } from '@nf/utils-common/constants';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
interface WcTagProps {
	className?: string;
}

interface WcTagButtonProps {
	size?: 'small' | 'medium';
	className?: string;
}

export const WcTag: React.FC<WcTagProps> = ({ className }) => {
	return (
		<div className={clsx(styles.rootS, className)}>
			<CdnImg 
				isGalaxyFolder={true}
				src="/images/promotion/worldcup2026/icon-tickets-disabled.svg"
				width={24}
				height={24}
			/>
		</div>
	);
}; 

export const WcTagButton = ({
	className,
	size = 'medium',
}: WcTagButtonProps) => {
	const { navigateToWcPromotionActivity } = useWcPromotionActivityNavigation();

	const handleClick = () => {
		setKafkaNormal({
			note: KafkaNote.WcPromotion2026,
			type: 1,
			action: 7
		});
		navigateToWcPromotionActivity();
	};

	return (
		<div className={clsx(styles.rootButton, className)} onClick={handleClick}>
			<CdnImg 
				isGalaxyFolder={true}
				src={`/images/promotion/worldcup2026/wc-tag/league-tag-${size}.png`}
				width={size === 'small' ? 34 : 73}
				height={22}
			/>
		</div>
	);
};

export const WcProductTag = () => {
	const assetLocale = useWcPromotionActivityAssetLocale();

	return (
		<div className={styles.rootProductTag}>
			<CdnImg 
				isGalaxyFolder={true}
				src={`/images/promotion/worldcup2026/wc-tag/product-tag/${assetLocale}.png`}
				width={99}
				height={42}
			/>
		</div>
	);
};